import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"


import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";



const vWB_Modeling_Session_RefR_Fields: { [id: string]: ISearchProviderField } = {
    WB_MODELING_SESSION_REFR_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB RefR Id', columnResourceName: 'colRefRId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    WB_MODELING_SESSION_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB MS Id', columnResourceName: 'colMSId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Customer Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {profileId: "ModelingSessionRefValuesOverrideSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}
    },
    PRODUCT_GROUP_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Product Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    MODEL_PREDICTOR_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Predictor Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    REF_VALUE: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Reference Value', columnResourceName: 'colRefVal', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 50 }
    },


}

const vWB_RefR_KeyFields =
    {
        id:    'WB_MODELING_SESSION_REFR_ID',
        id_ui: '',
        name:  ''
    }


class ModelingSessionRefValuesOverrideSearchProvider
    implements ISearchProvider {

    aModelingSessionWBId = -1

    constructor(WB_MODELING_SESSION_ID: number) {
        this.aModelingSessionWBId = WB_MODELING_SESSION_ID
    }

    get keyFields() {
        return vWB_RefR_KeyFields
    }

    get searchProviderFields() {
        return vWB_Modeling_Session_RefR_Fields
    }

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Modeling_Session_RefR_Search',
                this.searchProviderFields,
                [])

            SearchUtils.intersectFilter(findRequest, "WB_MODELING_SESSION_ID", [this.aModelingSessionWBId])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

class ModelingSessionRefValuesOverrideSearchProfile
    implements ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "ReferenceValuesOverride"
    profileName = "Find Reference Values"
    renderOptions = {ui5ResourceId: "ModelingSessionRefValuesOverrideProfile"}

    profileFilter = [
        {profileFilterName: 'Customer', searchProviderFieldId: 'CUSTOMER_NAME',          bMultiSelect: true, renderOptions: {}},
        {profileFilterName: 'Product', searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: {}},
        {profileFilterName: 'Predictor', searchProviderFieldId: 'MODEL_PREDICTOR_NAME', renderOptions: {}}
    ]

    profileDisplayFields = [
        'CUSTOMER_NAME', 'PRODUCT_GROUP_NAME', 'MODEL_PREDICTOR_NAME', 'REF_VALUE'
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = []
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""   //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];

    constructor(WB_MODELING_SESSION_ID: number) {
        this.aSearchProvider = new ModelingSessionRefValuesOverrideSearchProvider(WB_MODELING_SESSION_ID)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}


export class ModelingSessionRefValuesOverrideSearch
    implements ISearch {

    constructor(WB_MODELING_SESSION_ID: number, options?: any) {
        this.searchProfiles = [new ModelingSessionRefValuesOverrideSearchProfile(WB_MODELING_SESSION_ID)]
    }

    searchName = "Find Reference Values"
    renderOptions = {ui5ResourceId: "ModelingSessionRefValuesOverrideSearch"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true


}
